import {MovieService, PageService, AuthService} from 'hasta-la-vista-middleware-api/service'
import Vue from 'vue'
import MetaData from  '../../../mixins/meta-data.js'

export default {
  name: 'club-loyalty-info',

  mixins: [MetaData],

  data(){
    return {
      page: [],
      cinemas: [],
      loading: true,
      movies:null ,
      discoveryMembershipNumber:'',
      UserName:'',
      UserEmail:'',
      month:'',
      day:'',
      year:'',
      cinema_selected: null,
      fullPrice: '',
      edgarsPrice: '',
      vitalityPrice: '',
      active2d: false,
      active3d: false,
      user: true,
      isGuest: true,
      url: this.$route.params.card_name,
      showOtherPricing: false,
      loadingResendActivation: false
    }
  },

  computed: {
    cinemaType() {
      return ['2D', '3D']
    }
  },

  methods: {
    getAsyncData(){
        if (this.url === 'SK_Club') {
          this.metaTitle = 'Join Our Movie Club'
          this.metaDescription = 'SK Club members enjoy Access Rewards such as exclusive invitations to pre-screenings and events, the SK Club lounge at Gateway and Eastgate, and pre-bookings for SK Club exclusive events. Join today!'
        }
        if (this.url === 'Discovery_Vitality') {
          this.metaTitle = 'Discovery Vitality Movie Discounts | Movie Loyalty Programmes'
          this.metaDescription = 'Discovery Vitality members, experience the latest movies at discounted prices when you activate your Vitality Ster-Kinekor movie benefit. Find out more and activate your Vitality Ster-Kinekor movie benefit today!'
        }
        if (this.url === 'Edgars_Club') {
          this.metaTitle = 'Edgars Club Movie Discounts | Movie Loyalty Programmes'
          this.metaDescription = 'Edgars Club Life and Club VIP Members receive exciting movie discounts. If you don\'t have an Edgars Club Card yet, get one at an Edgars store today or call 0800 20 39 25 to join. Find out more!'
        }
        this.$emit('updateHead');
    },

    getContent() {
      this.loading = true;
      // let url = this.$route.params.card_name
      Promise.all([PageService.getGeneralPage("Movie_Cards", null),MovieService.getMovies(), PageService.getCinemaPrices(null), AuthService.isGuestUser(), AuthService.user()]).then(([cards,movies, cinemaPrices, guest, user])=> {
        this.page = cards[0].Movie_Cards[this.url];
        this.cinemas = cinemaPrices.data;
        this.movies = movies.byRelease();
        this.loading = false;
        this.isGuest = guest
        this.user = user

        // console.log("guest", guest)
        // console.log("user", this.user)
        Vue.nextTick(()=>{
          if (this.$route.hash) {
            window.scroll({top: this.$el.querySelector(this.$route.hash).offsetTop, left: 0})
          }
        })
      })
      this.getAsyncData()
    },

    selectCinemaType(vitality, edgars, fullprice) {
      this.vitalityPrice = vitality
      this.edgarsPrice = edgars
      this.fullPrice = fullprice
    },

    resendVerification(){
          this.loadingResendActivation = true
          AuthService.resendActivation().then(()=> {
            this.loadingResendActivation = false
              // this.$emit('change', true);
              // this.showUserActivation = false;
              // this.activationLoading = false;
          });
      },
  },

  created() {
    this.getContent()

  },

  mounted(){
        window.scroll({top: 0, left: 0})
  },
  
  watch: {
    '$route' (to, from) {
      if (from.path != to.path && !to.hash) {
        this.url = to.params.card_name
        this.getContent()
        this.getAsyncData()
      }
    },

    cinema_selected(e) {
      this.selectCinemaType(e['2d_vitality'], e['2d_edgars'], e['2d_full_price'], this.active2d = true, this.active3d = false)
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/pages/club-loyalty-info/club-loyalty-info.js